import { app } from '../../../../../../app';
import { Controller } from './import-completed.controller';

app.component('companySharingCenterImportCompleted', {
	bindings: {
        companyId: '<',
        labels$: '<'
    },
    controller: Controller,
    templateUrl: require('./import-completed.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import-csv/import-completed/import-completed.component.js